export function acceptedImageTypes() {
  return ['image/svg+xml', 'image/jpeg', 'image/png'];
}
